import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import { createBreadcrumbObject, createPaths, rebase } from "../../../utils";

// Base route constant
const baseRoute = `/course-management`;

// * Route configuration object for courses-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const coursesRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:courseId`,
  edit: `${baseRoute}/edit/:courseId`,
} as const;

// ! these are breadcrumbs translation not page title
const coursesRouteTranslation: IRouteTranslation<typeof coursesRoutesObj> = {
  list: "coursesManagement",
  create: "addCourse",
  edit: "editCourse",
  view: "viewCourse",
};

// * Extracts the route parameters for the courses route configuration.
export type ICoursesRouteParams = IExtractRouteParamMap<
  typeof coursesRoutesObj
>;

// * Path functions for the courses routes.
export const coursesPath = createPaths<
  typeof coursesRoutesObj,
  ICoursesRouteParams
>(coursesRoutesObj);

// * Breadcrumbs {translation and route} for the media routes
export const coursesBreadcrumbs = createBreadcrumbObject<
  typeof coursesRoutesObj
>(coursesRoutesObj, coursesRouteTranslation);
rebase(coursesBreadcrumbs, "list");
